import classnames from 'classnames';
import React from 'react';
import styles from './close-button.scss';
import CloseTickIcon from '../../icons/compiled/components/CloseTickIcon';
import { InlineIcon } from '../inline-icon/inline-icon';
export const CloseButton = ({ className, ariaLabel, dataHook, theme = 'light', onClick, }) => (React.createElement("button", { onClick: onClick, className: classnames(styles[theme], className), tabIndex: 0, "aria-label": ariaLabel, "data-hook": dataHook },
    React.createElement(InlineIcon, { icon: React.createElement(CloseTickIcon, null), className: styles.icon })));
//# sourceMappingURL=close-button.js.map